import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import * as Sentry from '@sentry/react';
import { ErrorResponse } from '@repo/types';
import { ApiError, getSentryLevel } from '@repo/utils';
import {
  STORE_GLOBAL_ERROR_CODE_VALUES,
  STORE_REFUND_ERROR_CODE_VALUES,
  STORE_TOURIST_ERROR_CODE_VALUES,
} from '@repo/constants';

export const axiosRequestConfiguration: AxiosRequestConfig = {
  baseURL: 'http://192.168.1.131:20921',
  responseType: 'json',
  headers: {
    Authorization: 'successmode806',
  },
};

export const axiosInstance = axios.create(axiosRequestConfiguration);

const exception400Error = (errorCode: string | undefined) => {
  if (STORE_TOURIST_ERROR_CODE_VALUES.includes(errorCode as any)) {
    return `ApiTouristExceptionError: ${errorCode}`;
  }
  if (STORE_REFUND_ERROR_CODE_VALUES.includes(errorCode as any)) {
    return `ApiRefundExceptionError: ${errorCode}`;
  }
  if (STORE_GLOBAL_ERROR_CODE_VALUES.includes(errorCode as any)) {
    return `ApiGlobalExceptionError: ${errorCode}`;
  }
  return 'ApiBadRequestError';
};

axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    return res;
  },
  async (error: AxiosError<ErrorResponse>) => {
    const newError = new ApiError(
      error,
      error?.response?.data.message,
      exception400Error,
    );
    const code = newError?.response?.data?.code;

    Sentry.withScope((scope) => {
      scope.setExtra('status', newError?.response?.status);
      scope.setExtra('response', newError?.response?.data);
      scope.setExtra('url', newError.config?.url);
      scope.setExtra('method', newError.config?.method);
      scope.setExtra('baseURL', newError.config?.baseURL);
      scope.setExtra('data', newError.config?.data);
      scope.setExtra('headers', newError.config?.headers);
      Sentry.captureException(newError, {
        level: getSentryLevel(newError?.response?.status || 500),
      });
    });

    switch (code) {
      case 'Unknown': {
        alert(
          'An unknown error occurred. Please refresh and try again in a few minutes.',
        );
        break;
      }
      case undefined: {
        alert(
          'The network condition is unstable. Please refresh and try again in a few minutes.',
        );
        break;
      }
    }
    return Promise.reject(newError?.response);
  },
);
